export const actionTypes = {
    SET_ACTIVE_TAB: 'maintenanceOverviewV2/SET_ACTIVE_TAB',
    SET_FILTERS: 'maintenanceOverviewV2/SET_FILTERS',
    CLEAR_STORE: 'maintenanceOverviewV2/CLEAR_STORE',
    GET_ASSETS: 'maintenanceOverviewV2/GET_ASSETS',
    GET_POWERTRAINS: 'maintenanceOverviewV2/GET_POWERTRAINS',
    GET_ASSETS_FOR_CBM: 'maintenanceOverviewV2/GET_ASSETS',
    GET_POWERTRAINS_FOR_CBM: 'maintenanceOverviewV2/GET_POWERTRAINS',

    SET_SELECTED_ASSET_DETAILS: 'powertrainAssetDetails/SET_SELECTED_ASSET',
    SET_SELECTED_ASSET: 'powertrainAssetsOverviewV2/SET_SELECTED_ASSET',
};

export const CLASSNAME_DUE = {
    OVER_DUE: 'overdue',
    DUE: 'due'
};
